import { Box3, Vector3 } from 'three';

export interface CameraFit {
  target: Vector3;
  position: Vector3;
}

const DEFAULT_DIAG = 8;

/**
 * Compute camera target + position to frame a scene bbox.
 * Camera placed at (diag*1.2, diag*0.8, diag*1.2) offset from bbox center.
 * Pulled slightly further back and higher than the original [1, 0.7, 1] to
 * show the building wall + ramp descent + ground exit simultaneously.
 */
export function computeCameraFit(bbox: Box3): CameraFit {
  const center = new Vector3();
  const size = new Vector3();

  if (bbox.isEmpty()) {
    return {
      target: new Vector3(0, 1, 0),
      position: new Vector3(DEFAULT_DIAG * 1.2, DEFAULT_DIAG * 0.8, DEFAULT_DIAG * 1.2),
    };
  }

  bbox.getCenter(center);
  bbox.getSize(size);
  const diag = Math.max(size.length(), 1);

  const position = center.clone().add(new Vector3(diag * 1.2, diag * 0.8, diag * 1.2));
  return { target: center.clone(), position };
}
